module.exports = __webpack_public_path__ + "img/xiamian.1a826de7.png";